const sections = [];

sections.push(
  {
    name: "login",
    paths: ["/login"],
    module: "login",
    enableLoggedOut: true,
  },
  {
    name: "eureka-callback",
    paths: ["/login/callback/eureka"],
    module: "login",
    enableLoggedOut: true,
  },
  {
    name: "new-password-required",
    paths: ["/login/new-password-required"],
    module: "login",
    group: "login",
    enableLoggedOut: true,
  },
  {
    name: "lost-password",
    paths: ["/login/lost-password"],
    module: "login",
    group: "login",
    enableLoggedOut: true,
  },
  {
    name: "signup",
    paths: ["/start"],
    module: "signup",
    enableLoggedOut: true,
  },
  {
    name: "dashboard",
    paths: ["/", "/decks", "/decks/[^\\/]+"],
    module: "dashboard",
  },

  {
    name: "me",
    paths: ["/me"],
    module: "me",
    secondary: true,
  },

  {
    name: "reports",
    paths: ["/reports"],
    module: "reports",
    secondary: true,
  },

  {
    name: "account",
    paths: ["/me/account"],
    module: "me/account",
    group: "me",
  },
  {
    name: "purchases",
    paths: [
      "/me/purchases",
      "/purchases",
      "/me/billing",
      "/me/purchases/add-credit-card",
    ],
    module: "me/purchases",
    group: "me",
    secondary: true,
  },
  {
    name: "security",
    paths: ["/me/security", "/me/security/connected-accounts"],
    module: "me/security",
    group: "me",
  },
  {
    name: "connections",
    paths: ["/me/security", "/me/connections"],
    module: "me/connected-accounts",
    group: "me",
  },
  {
    name: "preferences",
    paths: ["/me/preferences"],
    module: "me/account-preferences",
    group: "me",
  },

  {
    name: "data",
    paths: ["/me/data"],
    module: "me/data",
    group: "me",
  },
  {
    name: "editor",
    paths: ["/editor"],
    module: "dashboard/editor",
    group: "editor",
  },
  {
    name: "report-builder",
    paths: ["/report-builder/new", "/report-builder/[^\\/]+/edit"],
    module: "report-builder",
    group: "report-builder",
  },
  {
    name: "chat",
    paths: ["/chat", "/chat/[^\\/]+"],
    module: "chat-bot",
    secondary: "true",
  },
);

module.exports = sections;
